import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setBreadCrumb } from "../../../../store/userSlice";
import { useLocation, useNavigate } from "react-router-dom";
import SettlementPreviewDetails from "../FinalExit/SettlementPreview/SettlementPreviewDetails";
import LocalFinalExitList from "./LocalFinalExitList";
import nodeinstance from "../../../../nodeInstance";

export default function LocalFinalExit() {
  const token = localStorage.getItem("nodeToken");
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [id, setId] = useState();
  const [propData, setPropsData] = useState("");
  const [searchData, setSearchData] = useState({ data: [] });
  const [isLoading, setIsLoading] = useState(false);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  const isCreateMode = location.pathname.endsWith("/settlement-preview/details/");
  const commonItems = [
    { label: "Settlement Preview", link: "/dashboard/settlement-preview" },
  ];
  const breadcrumbItems = isCreateMode
    ? [...commonItems, { label: id, link: "" }]
    : commonItems;

  const getFinalExitData = async (employeeId = null) => {
    try {
      // If employee ID is provided, use the new search endpoint
      if (employeeId && employeeId.trim() !== "") {
        setIsLoading(true);
        const response = await nodeinstance.get(
          `/demobilization/searchAllEmployees`,
          {
            params: {
              employeeId: employeeId.trim(),
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 200) {
          setSearchData({ data: response.data.data || [] });
          localStorage.setItem("localFinal", "false");
        }
        setIsLoading(false);
      } else {
        // If no employee ID, clear the data
        setSearchData({ data: [] });
        setIsLoading(false);
      }
    } catch (error) {
      console.log("error to be printed in the console", error);
      setSearchData({ data: [] });
      setIsLoading(false);
    }
  };

  const tokenData = localStorage.getItem("localFinal");

  useEffect(() => {
    if (tokenData === "true") {
      getFinalExitData();
    }
  }, [tokenData]);

  const updateAPI = () => {
    getFinalExitData();
  };

  useEffect(() => {
    if (location.pathname.split("/")[3] === "details") {
      setAddOrEdit((p) => ({ ...p, open: true }));
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location]);

  useEffect(() => {
    dispatch(setBreadCrumb(breadcrumbItems));
  }, [location.pathname, id]);

  // Debug logging
  console.log("LocalFinalExit - id:", id);
  console.log("LocalFinalExit - propData:", propData);
  console.log("LocalFinalExit - addOrEdit.open:", addOrEdit.open);
  console.log("LocalFinalExit - location.pathname:", location.pathname);

  return (
    <>
      <div className={`ml-5 mr-5`}>
        {!addOrEdit.open && (
          <div className={`p-2 sm:p-5`}>
            <LocalFinalExitList
              list={searchData.data}
              titles={[
                "S.NO.",
                "POINT OF HIRE",
                "EMPLOYEE ID",
                "EMPLOYEE NAME",
                "NATIONALITY",
                "ACTUAL PROFESSION",
                "VISA PROFESSION",
                "BASIC",
                "SALARY",
                "TOTAL SALARY",
                "CLIENT",
                "VISA PROVIDER",
                "IQAMA NUMBER",
                "IQAMA EXPIRY DATE",
                "STATUS",
                "FINAL REMARKS",
                "ACTION",
              ]}
              setId={setId}
              setPropsData={setPropsData}
              updateData={updateAPI}
              onSearch={getFinalExitData}
              isLoading={isLoading}
            />
          </div>
        )}
        {addOrEdit.open && id && (
          <SettlementPreviewDetails
            employeeID={id}
            isLocalExit={true}
          />
        )}
        {addOrEdit.open && !id && (
          <div className="p-10 text-center">
            <p className="text-red-500">Employee ID not found. Please go back and select an employee.</p>
            <button
              className="mt-4 p-2 px-4 bg-blue text-white rounded-md"
              onClick={() => {
                setAddOrEdit({ open: false });
                navigate("/dashboard/settlement-preview");
              }}
            >
              Go Back
            </button>
          </div>
        )}
      </div>
    </>
  );
}
